"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NavigationButton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _FormattedMessage = require("../FormattedMessage");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const NavigationButton = (props)=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const { isDisabled, isSelected, onClick, navigationButtonTestId, stepNumber, stepLabelKey } = props;
    const ownerState = {
        isSelected
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.StepButton, {
        disableRipple: true,
        disableUppercase: true,
        variant: "text",
        size: "small",
        ownerState: ownerState,
        disabled: isDisabled,
        onClick: onClick,
        ...getTestIdProps(navigationButtonTestId),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.StepText, {
            component: "span",
            children: [
                stepNumber,
                ". ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                    id: stepLabelKey
                })
            ]
        })
    });
};
exports.NavigationButton = NavigationButton;
